import { useEffect, useState } from 'react';
import { Flex, Image, theme } from '../../../2022-component-library';
import { useImageDrag } from '../../../helpers/forth-valley-hooks';
import styled from '@emotion/styled';
import ImageZoomSlider from '../../../2022-component-library/src/components/ImageZoomSlider';
import { useBreakpoints } from '../../../helpers/useBreakpoints';

const ZoomedImageContainer = styled(Flex)`
  width: clamp(125px, 17.5vw, 260px);
  aspect-ratio: 1.5;
  margin-bottom: 0.75rem;
  overflow: hidden;
  background-color: ${theme.colors.primaryTint};
`;

const EyeMotilityResults = ({ showImages, showVideo, testData, usingOldImages }) => {
  const [imageZoomValues, setImageZoomValues] = useState({ img0: 1.0, img1: 1.0, img2: 1.0, img3: 1.0 });
  const [imageDragValues, setImageDragValues] = useState({ img0: { x: 0, y: 0 }, img1: { x: 0, y: 0 }, img2: { x: 0, y: 0 }, img3: { x: 0, y: 0 } });
  const [imageArray, setImageArray] = useState([]);
  const [videoSrc, setVideoSrc] = useState(null);
  const [imageBeingDragged, setImageBeingDragged] = useState(null);
  const { translateX, translateY, beginDrag } = useImageDrag();
  const { breakpoints } = useBreakpoints();

  const getImgAltTextFromCornerNumber = (number) => {
    switch (number) {
      case 0:
        return 'top-left';
      case 1:
        return 'top-right';
      case 2:
        return 'bottom-left';
      case 3:
        return 'bottom-right';
      default:
        break;
    }
  };

  useEffect(() => {
    if (testData?.video?.url) return setVideoSrc(testData.video.url);
    return setVideoSrc(JSON.parse(localStorage.getItem('videoRecordingData')));
  }, [testData]);

  useEffect(() => {
    const cornerFixationImages = testData?.hasOwnProperty('images') ? testData.images : JSON.parse(localStorage.getItem('cornerFixationImages'));

    const desiredIndexOrder = [1, 0, 3, 2];

    if (cornerFixationImages) {
      const sortedArray = desiredIndexOrder.map((i) => {
        return cornerFixationImages[i];
      });

      setImageArray(sortedArray);
    }
  }, [testData]);

  useEffect(() => {
    let finalX = translateX;
    let finalY = translateY;
    const maximumX = 150;
    const maximumY = 100;
    if (translateX > maximumX) finalX = maximumX;
    if (translateX < 0 && translateX < maximumX * -1) finalX = maximumX * -1;
    if (translateY > maximumY) finalY = maximumY;
    if (translateY < 0 && translateY < maximumX * -1) finalY = maximumY * -1;
    setImageDragValues((existingValues) => {
      return { ...existingValues, [imageBeingDragged]: { x: finalX, y: finalY } };
    });
  }, [imageBeingDragged, translateX, translateY]);

  return (
    <Flex>
      {showImages && (
        <Flex>
          {imageArray.length ? (
            <Flex flexWrap='wrap' centered gap='1rem' maxWidth={breakpoints('600px', '600px', '800px')}>
              {[0, 1, 2, 3].map((cornerNumber) => {
                return (
                  <Flex column centered key={`eye-motility-column-${cornerNumber}`}>
                    <ZoomedImageContainer>
                      <Image
                        onMouseDown={(e) => {
                          setImageBeingDragged(`img${cornerNumber}`);
                          beginDrag(e);
                        }}
                        src={
                          testData?.hasOwnProperty('images')
                            ? usingOldImages
                              ? imageArray[cornerNumber]
                              : imageArray[cornerNumber].url
                            : imageArray[cornerNumber]
                        }
                        alt={getImgAltTextFromCornerNumber(cornerNumber) + '-corner'}
                        id={`eye-motility-img-${cornerNumber}`}
                        width='100%'
                        style={{
                          cursor: 'pointer',
                          transition: 'transform 100ms',
                          transform: `scale(${imageZoomValues[`img${cornerNumber}`]}) ${`translate(${imageDragValues[`img${cornerNumber}`].x}px, ${
                            imageDragValues[`img${cornerNumber}`].y
                          }px)`}`,
                        }}
                      />
                    </ZoomedImageContainer>
                    <ImageZoomSlider
                      id={`eye-motility-slider-${cornerNumber}`}
                      value={imageZoomValues[`img${cornerNumber}`]}
                      onChange={(e) => {
                        setImageZoomValues({ ...imageZoomValues, [`img${cornerNumber}`]: e.target.value });
                      }}
                    />
                  </Flex>
                );
              })}
            </Flex>
          ) : (
            'No images could be found.'
          )}
        </Flex>
      )}
      {showVideo && (
        <Flex width='100%'>
          {Object.keys(videoSrc || {}).length ? (
            <video height={breakpoints(200, 275, 375)} width='auto' controls>
              <source src={videoSrc} type='video/mp4' />
            </video>
          ) : (
            'Video recording cannot be displayed.'
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default EyeMotilityResults;
